import * as React from 'react';
import UITable from 'UIComponents/table/UITable';
import UISection from 'UIComponents/section/UISection';
import FormattedMessage from 'I18n/components/FormattedMessage';
import WalmartFormSubmissionFilterEvaluationDataRow from 'flow-doctor-lib/components/filters/WalmartFormSubmissionFilterEvaluationDataRow';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const WalmartFormSubmissionFilterEvaluationData = ({
  evalData
}) => {
  if (evalData.formSubmissions.length === 0) {
    return /*#__PURE__*/_jsx(UISection, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.filterEvals.popover.missingFormSubmissions"
      })
    });
  }
  return /*#__PURE__*/_jsxs(UITable, {
    condensed: true,
    children: [/*#__PURE__*/_jsx("thead", {
      children: /*#__PURE__*/_jsxs("tr", {
        children: [/*#__PURE__*/_jsx("th", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.filterEvals.popover.fields.form"
          })
        }), /*#__PURE__*/_jsx("th", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.filterEvals.popover.fields.page"
          })
        }), /*#__PURE__*/_jsx("th", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.filterEvals.popover.fields.timeSubmitted"
          })
        })]
      })
    }), /*#__PURE__*/_jsx("tbody", {
      children: [...evalData.formSubmissions].reverse().map((formSubmissionData, i) => /*#__PURE__*/_jsx(WalmartFormSubmissionFilterEvaluationDataRow, {
        formSubmissionData: formSubmissionData
      }, i))
    })]
  });
};
export default WalmartFormSubmissionFilterEvaluationData;